import * as React from 'react';
import { FilterAnchor, type FilterLink } from '@chess/api-insights/charts';
import type { WeekColumn } from './cards.ts';

// Week by week: four columns, oldest week at the left, each as tall as the
// week's mistakes per scanned game, its rate above it and the week under it.
// A column opens the week's games with such a mistake in the library
// (`mistake=<kind>-week-<n>`); a week without scanned games shows a dash.
// Drawn from props only.

export const WeekColumns: React.FC<{ columns: WeekColumn[]; colour: string; noun: string; link?: FilterLink }> = ({ columns, colour, noun, link }) => {
  const max = Math.max(...columns.map((c) => c.rate ?? 0), 0) || 1;
  return (
    <div className="mistake-weeks" role="list" aria-label={`${noun} per game, week by week`}>
      {columns.map((c) => {
        const to = c.games ? link : undefined;
        const title =
          c.rate === undefined
            ? `${c.label}: no scanned games`
            : `${c.label}: ${c.mistakes} ${noun} in ${c.scanned} scanned ${c.scanned === 1 ? 'game' : 'games'} (${c.rate.toFixed(1)} per game)${c.games ? ' · opens those games' : ''}`;
        return (
          <div key={c.key} role="listitem" className="mistake-week" title={title}>
            <span className="mistake-week-value">{c.rate === undefined ? '—' : c.rate.toFixed(1)}</span>
            <span className="mistake-week-track">
              {!!c.rate && (
                <FilterAnchor className="mistake-week-fill" link={to} filter={{ mistake: c.key }} style={{ height: `${(100 * c.rate) / max}%`, background: colour }}>
                  {null}
                </FilterAnchor>
              )}
            </span>
            <FilterAnchor className="mistake-week-label" link={to} filter={{ mistake: c.key }}>
              {c.label}
            </FilterAnchor>
          </div>
        );
      })}
    </div>
  );
};
